<template lang="pug">
  v-container
    v-card
      v-card-title
        | Option List
        .flex-grow-1
        v-text-field.mt-n4(v-model='search' append-icon='mdi-magnify' label='Search' single-line hide-details fixed-header @keyup.enter="fetchOptions()" clearable)
        v-tooltip(bottom)
          template(v-slot:activator="{ on }")
            v-btn.ml-4(icon v-on="on" @click="dialog = true")
              v-icon(large) mdi-playlist-plus
          span Add Option
      v-data-table(:headers='headers' :items='prod_options' :options.sync="options" :server-items-length="totalOptions" disable-sort)
        template(v-slot:item.title='{ item }')
          div(:class="item.clazz ? 'yellow--text' : ''") {{ item.title }}
        template(v-slot:item.cost_price='{ item }') {{ 'RM ' + senToRM(item.cost_price) }}
        template(v-slot:item.sell_price='{ item }') {{ 'RM ' + senToRM(item.sell_price) }}
        template(v-slot:item.normal_price='{ item }') {{ 'RM ' + senToRM(item.normal_price) }}
        template(v-slot:item.action='{ item }')
          v-btn(icon)
            v-icon(small @click='editItem(item)') mdi-pencil
          v-btn(icon)
            v-icon(small @click='deleteItem(item)') mdi-delete
      v-dialog(v-model='dialog' persistent max-width='600px')
        v-card
          v-card-title
            span.headline {{ ae_option.id ? 'Edit Option' : 'Add Option' }}
          v-card-text
            v-container
              v-row
                v-col(cols="12")
                  v-select(v-model="ae_option.provider" :items="provider" label="Provider")
                  v-autocomplete(v-model="ae_option.product" :items="product" item-text="original_title" item-value="id" label='Product')
                  v-text-field(v-model="ae_option.title" label="Title")
                  v-text-field(v-model="ae_option.sell_price" label="Sell Price" prefix="RM" type="number" step="0.01")
                  v-text-field(v-model="ae_option.cost_price" label="Cost Price" prefix="RM" type="number" step="0.01")
                  v-text-field(v-model="ae_option.normal_price" label="Normal Price" prefix="RM" type="number" step="0.01")
          v-card-actions
            v-spacer
            v-btn(color="red darken-3" text @click="closeDialog") Close
            v-btn.mr-4(color="teal" text @click='saveOption') {{ ae_option.id ? 'Save' : 'Add New' }}
</template>

<script>
export default {
  name: 'Options',
  data: () => ({
    search: '',
    options: {},
    headers: [
      { text: 'Product', value: 'product.original_title', width: '25%' },
      { text: 'Provider', value: 'provider'},
      { text: 'Title', value: 'title', width: '25%' },
      { text: 'Cost Price', value: 'cost_price' },
      { text: 'Sell Price', value: 'sell_price' },
      { text: 'Normal Price', value: 'normal_price' },
      { text: 'Action', value: 'action', sortable: false, width: '10%', align: 'center' }
    ],
    prod_options: [],
    totalOptions: 0,
    dialog: false,
    ae_option: {},
    provider:['ARBA', 'GBTX', 'NNTA', 'PLCM', 'TCRT', 'CBTV', 'KLOK', 'ONVC', 'BMGS', 'MPLC'],
    product: []
  }),
  watch: {
    options: {
      handler () {
        // console.log(this.options)
        this.fetchOptions(this.options.page, this.options.itemsPerPage)
      },
      deep: true
    }
  },
  mounted () {
    this.fetchOptions()
    this.fetchProduct()
  },
  methods: {
    fetchOptions (page = 1, itemsPerPage = 10) {
      this.$axios.get(`/options/?ordering=title&page=${page}&page_size=${itemsPerPage}&search=${this.search}`)
        .then(resp => {
          this.prod_options = [...resp.data.results]
          this.totalOptions = resp.data.count
        })
    },
    fetchProduct () {
      this.$axios.get(`/products/?page_size=-1`)
        .then(resp => {
          this.product = [...resp.data.results]
          this.totalOptions = resp.data.count
        })
    },
    senToRM (val) {
      return (parseInt(val)/100).toFixed(2)
    },
    RMtoSen (val) {
      return (parseInt(val)*100)
    },
    editItem (item) {
      this.dialog = true
      this.ae_option = { ...item, cost_price: this.senToRM(item.cost_price), sell_price: this.senToRM(item.sell_price), normal_price: this.senToRM(item.normal_price) }
    },
    deleteItem (item) {
      confirm('Are you sure you want to delete this product?') && 
      this.$axios.delete(`/options/${item.id}/`)
        .then(resp => {
          this.$showAlert('grey darken-2','Delete Option Successful!')
          this.fetchOptions()
          this.fetchProduct() 
        })
        .catch(err => {
          console.log(err)
          this.$alert.failed('Delete Option Failed!')
        })
    },
    closeDialog () {
      this.dialog = false
      this.ae_option = {}
    },
    saveOption () {
      if (this.ae_option.id) {
        let data = {
          title: this.ae_option.title,
          cost_price: this.RMtoSen(this.ae_option.cost_price),
          sell_price:  this.RMtoSen(this.ae_option.sell_price),
          normal_price: this.RMtoSen(this.ae_option.normal_price),
          provider: this.ae_option.provider,
          product: this.ae_option.product.id
        }
        this.$axios.patch(`/options/${this.ae_option.id}/`, data)
          .then(resp => {
            if (resp.data.id) {
              this.$alert.success('Update Option Successful!')
              this.fetchOptions()
              this.fetchProduct()
            } else {
              this.$alert.failed('Update Option Failed!')
            }
          })
      } else {
        let data = {
          order: 0,
          title: this.ae_option.title,
          sell_price: this.RMtoSen(this.ae_option.sell_price),
          cost_price: this.RMtoSen(this.ae_option.cost_price),
          normal_price: this.RMtoSen(this.ae_option.normal_price),
          provider: this.ae_option.provider,
          provider_ref: {},
          raw: {},
          product: this.ae_option.product,
          clazz: null,
          locale: 1
        }
        this.$axios.post(`/options/`, data)
          .then(resp => {
            if (resp.data.id) {
              this.$alert.success('Add Option Successful!')
              this.fetchOptions()
              this.fetchProduct()
            } else {
              this.$alert.failed('Add Option Failed!')
            }
          })
      }
      this.closeDialog()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>